import React from 'react';
import { VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import Pressable from '~/shared/Pressable';
import { useI18n, useSpringBigStore } from '@springbig/shared';
import { useGeneralStyles } from '~/shared/styles';

const FooterTemplate = () => {

    const { merchantName } = useSpringBigStore();

    const { t } = useI18n();

    const handleLinkPress = (url: string): void => {
        if (!url) {
            return;
        }
        
        window.open(url, '_blank');
    };
    
    const gStyle = useGeneralStyles();

    return (
        <VStack mb={4}>
            <Caption fontSize="10" textAlign="center">
                {t('footerTemplate.message_disclaimer')}
            </Caption>
            <Caption fontSize="10" textAlign="center">
                {merchantName && `© ${new Date().getFullYear()} ${merchantName} `}
                <Pressable onPress={() => handleLinkPress('https://my.securelinkit.com/privacy')}>
                    <Caption fontSize="10" color={gStyle.link} underline>
                        {t('footerTemplate.privacy_policy')}
                    </Caption>
                </Pressable>
                {" "}|{" "}
                <Pressable onPress={() => handleLinkPress('https://my.securelinkit.com/terms_conditions')}>
                    <Caption fontSize="10" color={gStyle.link} underline>
                        {t('footerTemplate.terms_conditions')}
                    </Caption>
                </Pressable>
            </Caption>
        </VStack>
    );
};

export default FooterTemplate;
